var _circle, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAmeSymbol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 315 314",
    "aria-labelledby": "ameSymbolIcon ameSymbolDesc"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "inherit",
    cx: 157.5,
    cy: 157.5,
    r: 156.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M146.767 117.423c7.623 7.619 19.988 7.619 27.611 0l32.725-32.71c3.624-3.624 8.32-5.503 13.07-5.68V79h-119.2v.032c4.751.177 9.45 2.057 13.08 5.681l32.714 32.71z",
    fill: "#FFF",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M267.428 117.412l-32.713-32.7c-4-3.997-9.302-5.876-14.542-5.68-4.749.179-9.447 2.058-13.07 5.68l-32.724 32.71c-7.623 7.62-19.989 7.62-27.613 0l-32.713-32.71c-3.63-3.623-8.33-5.502-13.08-5.68-5.238-.195-10.539 1.684-14.542 5.68l-32.714 32.7c-7.622 7.63-7.622 19.992 0 27.623l93.05 93.022c7.623 7.62 19.989 7.62 27.612 0l93.05-93.022c7.634-7.631 7.634-19.992 0-27.623",
    fill: "#FFF"
  })));
}

export default SvgAmeSymbol;